import { TeamOutlined, UserAddOutlined } from '@ant-design/icons';
import OrderClientsList from 'components/pages/dashboard/ParcelOrder/components/orderPersonPicker/OrderClientsList';
import OrderCreateClient from 'components/pages/dashboard/ParcelOrder/components/orderPersonPicker/OrderCreateClient';
import TcModal from 'components/UI/Modal/TcModal';
import TcTab from 'components/UI/Tab/TcTab';
import { client } from 'global/Models/clientModel';
import { FC, memo, useCallback, useMemo, useState } from 'react';

interface IOrderPersonPicker {
  close(): void;
  visible: boolean;
  setClient: (_client: client) => void;
}

const OrderPersonPicker: FC<IOrderPersonPicker> = ({ close, visible, setClient }) => {
  //states
  const [activeTab, setActiveTab] = useState('1');

  //functions
  const handleClientSelect = useCallback((client: client) => {
    setClient(client);
    close();
  }, []);

  // const tabs = useMemo(
  //   () => [
  //     {
  //       label: (
  //         <span className='px-4'>
  //           <TeamOutlined />
  //           لیست مشتری ها
  //         </span>
  //       ),
  //       key: '1',
  //       children: <OrderClientsList setClient={handleClientSelect} />,
  //     },
  //     {
  //       label: (
  //         <span className='px-4'>
  //           <UserAddOutlined />
  //           فرد جدید
  //         </span>
  //       ),
  //       key: '2',
  //       children: <OrderCreateClient setClient={handleClientSelect} />,
  //     },
  //   ],
  //   []
  // );

  const tabs = useMemo(
    () => [
      {
        title: 'مشتری های من',
        icon: <TeamOutlined />,
        key: '1',
        content: <OrderClientsList setClient={handleClientSelect} />,
      },
      {
        title: 'ثبت فرد جدید',
        icon: <UserAddOutlined />,
        key: '2',
        content: <OrderCreateClient setClient={handleClientSelect} />,
      },
    ],
    []
  );

  return (
    <TcModal title='تعیین فرد' width={700} footer={false} onCancel={close} visible={visible}>
      {/* <Tabs centered items={tabs} /> */}
      <TcTab tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
    </TcModal>
  );
};

export default memo(OrderPersonPicker);
